/**
 * Detects if the current visitor is a search engine crawler or bot.
 * Used to skip loading screens and ensure content is immediately visible for SEO.
 */
export function isBot(): boolean {
  if (typeof navigator === 'undefined') return false;
  
  const botPatterns = [
    'googlebot', 'bingbot', 'yandexbot', 'duckduckbot',
    'slurp', 'baiduspider', 'facebookexternalhit',
    'twitterbot', 'linkedinbot', 'embedly', 'quora link preview',
    'showyoubot', 'outbrain', 'pinterest', 'applebot',
    'semrushbot', 'ahrefsbot', 'mj12bot', 'dotbot',
    'petalbot', 'gptbot', 'perplexitybot', 'claude-web',
    'rogerbot', 'screaming frog', 'lighthouse'
  ];
  
  const userAgent = navigator.userAgent.toLowerCase();
  return botPatterns.some(bot => userAgent.includes(bot));
}
